import {AfterViewInit, ChangeDetectionStrategy, Component, Input, OnChanges, TemplateRef} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
    selector: 'page-title-item',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTitleItemComponent implements OnChanges, AfterViewInit {
    @Input() link: string;
    @Input() href: string;
    @Input() content: TemplateRef<any>;
    changed$ = new Subject();

    ngOnChanges() {
        this.changedTitle();
    }

    ngAfterViewInit() {
        this.changedTitle();
    }

    changedTitle() {
        this.changed$.next();
    }
}
